import _objectWithoutProperties from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["state"],
    _excluded2 = ["fetchStatus"];
import "./chunk-PXG64RU4.js"; // src/hydration.ts

import { tryResolveSync } from "./thenable.js";

function defaultTransformerFn(data) {
  return data;
}

function dehydrateMutation(mutation) {
  return _objectSpread(_objectSpread({
    mutationKey: mutation.options.mutationKey,
    state: mutation.state
  }, mutation.options.scope && {
    scope: mutation.options.scope
  }), mutation.meta && {
    meta: mutation.meta
  });
}

function dehydrateQuery(query, serializeData, shouldRedactErrors) {
  var _a;

  return _objectSpread(_objectSpread({
    dehydratedAt: Date.now(),
    state: _objectSpread(_objectSpread({}, query.state), query.state.data !== void 0 && {
      data: serializeData(query.state.data)
    }),
    queryKey: query.queryKey,
    queryHash: query.queryHash
  }, query.state.status === "pending" && {
    promise: (_a = query.promise) == null ? void 0 : _a.then(serializeData).catch(function (error) {
      if (!shouldRedactErrors(error)) {
        return Promise.reject(error);
      }

      if (process.env.NODE_ENV !== "production") {
        console.error("A query that was dehydrated as pending ended up rejecting. [".concat(query.queryHash, "]: ").concat(error, "; The error will be redacted in production builds"));
      }

      return Promise.reject(new Error("redacted"));
    })
  }), query.meta && {
    meta: query.meta
  });
}

function defaultShouldDehydrateMutation(mutation) {
  return mutation.state.isPaused;
}

function defaultShouldDehydrateQuery(query) {
  return query.state.status === "success";
}

function defaultShouldRedactErrors(_) {
  return true;
}

function dehydrate(client) {
  var _ref, _options$shouldDehydr, _ref2, _options$shouldDehydr2, _ref3, _options$shouldRedact, _ref4, _options$serializeDat;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a, _b, _c, _d;

  var filterMutation = (_ref = (_options$shouldDehydr = options.shouldDehydrateMutation) !== null && _options$shouldDehydr !== void 0 ? _options$shouldDehydr : (_a = client.getDefaultOptions().dehydrate) == null ? void 0 : _a.shouldDehydrateMutation) !== null && _ref !== void 0 ? _ref : defaultShouldDehydrateMutation;
  var mutations = client.getMutationCache().getAll().flatMap(function (mutation) {
    return filterMutation(mutation) ? [dehydrateMutation(mutation)] : [];
  });
  var filterQuery = (_ref2 = (_options$shouldDehydr2 = options.shouldDehydrateQuery) !== null && _options$shouldDehydr2 !== void 0 ? _options$shouldDehydr2 : (_b = client.getDefaultOptions().dehydrate) == null ? void 0 : _b.shouldDehydrateQuery) !== null && _ref2 !== void 0 ? _ref2 : defaultShouldDehydrateQuery;
  var shouldRedactErrors = (_ref3 = (_options$shouldRedact = options.shouldRedactErrors) !== null && _options$shouldRedact !== void 0 ? _options$shouldRedact : (_c = client.getDefaultOptions().dehydrate) == null ? void 0 : _c.shouldRedactErrors) !== null && _ref3 !== void 0 ? _ref3 : defaultShouldRedactErrors;
  var serializeData = (_ref4 = (_options$serializeDat = options.serializeData) !== null && _options$serializeDat !== void 0 ? _options$serializeDat : (_d = client.getDefaultOptions().dehydrate) == null ? void 0 : _d.serializeData) !== null && _ref4 !== void 0 ? _ref4 : defaultTransformerFn;
  var queries = client.getQueryCache().getAll().flatMap(function (query) {
    return filterQuery(query) ? [dehydrateQuery(query, serializeData, shouldRedactErrors)] : [];
  });
  return {
    mutations: mutations,
    queries: queries
  };
}

function hydrate(client, dehydratedState, options) {
  var _ref5, _ref6;

  var _a, _b;

  if (typeof dehydratedState !== "object" || dehydratedState === null) {
    return;
  }

  var mutationCache = client.getMutationCache();
  var queryCache = client.getQueryCache();
  var deserializeData = (_ref5 = (_ref6 = (_a = options == null ? void 0 : options.defaultOptions) == null ? void 0 : _a.deserializeData) !== null && _ref6 !== void 0 ? _ref6 : (_b = client.getDefaultOptions().hydrate) == null ? void 0 : _b.deserializeData) !== null && _ref5 !== void 0 ? _ref5 : defaultTransformerFn;
  var mutations = dehydratedState.mutations || [];
  var queries = dehydratedState.queries || [];
  mutations.forEach(function (_ref7) {
    var state = _ref7.state,
        mutationOptions = _objectWithoutProperties(_ref7, _excluded);

    var _a2, _b2;

    mutationCache.build(client, _objectSpread(_objectSpread(_objectSpread({}, (_a2 = client.getDefaultOptions().hydrate) == null ? void 0 : _a2.mutations), (_b2 = options == null ? void 0 : options.defaultOptions) == null ? void 0 : _b2.mutations), mutationOptions), state);
  });
  queries.forEach(function (_ref8) {
    var queryKey = _ref8.queryKey,
        state = _ref8.state,
        queryHash = _ref8.queryHash,
        meta = _ref8.meta,
        promise = _ref8.promise,
        dehydratedAt = _ref8.dehydratedAt;

    var _a2, _b2;

    var syncData = promise ? tryResolveSync(promise) : void 0;
    var rawData = state.data === void 0 ? syncData == null ? void 0 : syncData.data : state.data;
    var data = rawData === void 0 ? rawData : deserializeData(rawData);
    var query = queryCache.get(queryHash);
    var existingQueryIsPending = (query == null ? void 0 : query.state.status) === "pending";
    var existingQueryIsFetching = (query == null ? void 0 : query.state.fetchStatus) === "fetching";

    if (query) {
      var hasNewerSyncData = syncData && // We only need this undefined check to handle older dehydration
      // payloads that might not have dehydratedAt
      dehydratedAt !== void 0 && dehydratedAt > query.state.dataUpdatedAt;

      if (state.dataUpdatedAt > query.state.dataUpdatedAt || hasNewerSyncData) {
        var _ignored = state.fetchStatus,
            serializedState = _objectWithoutProperties(state, _excluded2);

        query.setState(_objectSpread(_objectSpread({}, serializedState), {}, {
          data: data
        }));
      }
    } else {
      query = queryCache.build(client, _objectSpread(_objectSpread(_objectSpread({}, (_a2 = client.getDefaultOptions().hydrate) == null ? void 0 : _a2.queries), (_b2 = options == null ? void 0 : options.defaultOptions) == null ? void 0 : _b2.queries), {}, {
        queryKey: queryKey,
        queryHash: queryHash,
        meta: meta
      }), // Reset fetch status to idle to avoid
      // query being stuck in fetching state upon hydration
      _objectSpread(_objectSpread({}, state), {}, {
        data: data,
        fetchStatus: "idle",
        status: data !== void 0 ? "success" : state.status
      }));
    }

    if (promise && !existingQueryIsPending && !existingQueryIsFetching && ( // Only hydrate if dehydration is newer than any existing data,
    // this is always true for new queries
    dehydratedAt === void 0 || dehydratedAt > query.state.dataUpdatedAt)) {
      void query.fetch(void 0, {
        // RSC transformed promises are not thenable
        initialPromise: Promise.resolve(promise).then(deserializeData)
      });
    }
  });
}

export { defaultShouldDehydrateMutation, defaultShouldDehydrateQuery, dehydrate, hydrate };